import CategoryColor from '../schema/CategoryColor';
import CategoryType from 'owa-service/lib/contract/CategoryType';
import { DEFAULT_CATEGORY_COLOR_CODE } from '../schema/categoriesConstants';
import { isNumber } from 'mini-common-utils/lib/utils/isNumber';

const categoryToHexColorCodeMap = {
    [CategoryColor.None]: '#000000',
    [CategoryColor.Red]: '#E74856',
    [CategoryColor.Orange]: '#FF8C00',
    [CategoryColor.Peach]: '#FFAB45',
    [CategoryColor.YellowLight]: '#FFF100',
    [CategoryColor.GreenLight]: '#47D041',
    [CategoryColor.TealLight]: '#30C6CC',
    [CategoryColor.Olive]: '#73AA24',
    [CategoryColor.BlueSky]: '#00BCF2',
    [CategoryColor.PurpleLight]: '#8764B8',
    [CategoryColor.Pink]: '#F495BF',
    [CategoryColor.SteelLight]: '#A0AEB2',
    [CategoryColor.SteelGrey]: '#004B60',
    [CategoryColor.GreyLight]: '#B1ADAB',
    [CategoryColor.GreyDark]: '#5D5A58',
    [CategoryColor.Black]: '#000000',
    [CategoryColor.RedDark]: '#750B1C',
    [CategoryColor.OrangeDark]: '#CA5010',
    [CategoryColor.BrownMedium]: '#AB620D',
    [CategoryColor.YellowDark]: '#C19C00',
    [CategoryColor.GreenDark]: '#004B1C',
    [CategoryColor.TealDark]: '#004B50',
    [CategoryColor.OliveDark]: '#0B6A0B',
    [CategoryColor.BlueDark]: '#002050',
    [CategoryColor.PurpleDark]: '#32145A',
    [CategoryColor.MagentaDark]: '#5C005C',
};

/**
 * Returns the hex color code for a given category
 * @param category
 */
export const getHexColorCodeForCategory = (category: CategoryType): string => {
    const colorScheme =
        category && isNumber(category.Color) ? categoryToHexColorCodeMap[category.Color] : null;
    return colorScheme || getDefaultHexColorCodeForCategory();
};

/**
 * Returns the default hex color code to be used
 * @param category
 */
export const getDefaultHexColorCodeForCategory = (): string =>
    categoryToHexColorCodeMap[DEFAULT_CATEGORY_COLOR_CODE];
